export enum InteractionModeEnum {
  READONLY = 'READONLY',
  EDIT = 'EDIT',
}

export function getActionByString(actionString: string) {
  return Object.values(InteractionModeEnum).find((value) => {
    if (value.toLowerCase() == actionString.toLowerCase()) {
      return value;
    }
  });
}
